"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildInjectToForm = buildInjectToForm;
exports.roleKeys = exports.getFormExtraFields = exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _BaseInjectors = require("react-platform-components/dist/BaseComponents/BaseInjectors");
var _formFields = require("react-platform-components/dist/form-fields");
var _formValidators = require("react-platform-components/dist/form-validators");
var _RegisterForm = _interopRequireDefault(require("react-platform-user/dist/Register/RegisterForm"));
var _Translations = require("react-platform-components/dist/Translations");
var _config = require("../config");
var _excluded = ["form", "formExtraFields", "getInitialCategoryValue"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AddressOfStoreFields;
var setInitialAddressOfStoreValues;
var useAddressOfStore = false;
try {
  AddressOfStoreFields = require('react-platform-address-of-store/dist/AddressOfStore/AddressOfStoreFields').default;
  setInitialAddressOfStoreValues = require('react-platform-address-of-store/dist/AddressOfStore/AddressOfStoreFields').setInitialAddressOfStoreValues;
  useAddressOfStore = !!_config.INLINE_ADDRESS_OF_STORE_IN_REGISTER;
} catch (error) {}
var CategoryOfStoreField;
try {
  CategoryOfStoreField = require('react-platform-category-of-store/dist/CategoryOfStore/CategoryOfStoreField').default;
} catch (error) {}
var SpecificitiesOfStoreFields;
try {
  SpecificitiesOfStoreFields = require('react-platform-specificity-of-store/dist/SpecificityOfStore/SpecificitiesOfStoreFields').default;
} catch (error) {}
var storeFields = function storeFields(props) {
  return [/*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_formFields.TextField, {
    name: "name",
    label: "Store name",
    margin: "normal",
    variant: "outlined",
    fullWidth: true,
    required: true,
    validate: (0, _formValidators.required)()
  })))];
};
var getFormExtraFields = function getFormExtraFields(props) {
  var formFields = [/*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center",
    className: "pb-2 pt-8"
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1",
    style: {
      fontSize: '1.1rem',
      color: '#908f8f'
    }
  }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
    id: "Informations relatives au store"
  }))))];
  {
    CategoryOfStoreField && !_lodash.default.includes(props.hiddenFields, 'category') && formFields.push( /*#__PURE__*/_react.default.createElement(CategoryOfStoreField, props));
  }
  {
    formFields.push(storeFields(props));
  }
  {
    SpecificitiesOfStoreFields && formFields.push( /*#__PURE__*/_react.default.createElement(SpecificitiesOfStoreFields, {
      showSpecificitiesTitle: false,
      displayFieldCondition: function displayFieldCondition(specificity) {
        return Boolean(specificity === null || specificity === void 0 ? void 0 : specificity.displayed_on_register);
      }
    }));
  }
  {
    useAddressOfStore && formFields.push( /*#__PURE__*/_react.default.createElement(AddressOfStoreFields, _extends({}, props, {
      unusedFields: ['state']
    })));
  }
  return formFields;
};
exports.getFormExtraFields = getFormExtraFields;
var roleKeys = ['role'];
exports.roleKeys = roleKeys;
var handleInitialValuesKeys = function handleInitialValuesKeys() {
  var initialValuesKeys = ['name'];
  {
    _config.INLINE_ROLE_IN_REGISTER && initialValuesKeys.push(roleKeys);
  }
  return initialValuesKeys.flat();
};
function buildInjectToForm() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$form = _ref.form,
    form = _ref$form === void 0 ? _RegisterForm.default : _ref$form,
    _ref$formExtraFields = _ref.formExtraFields,
    formExtraFields = _ref$formExtraFields === void 0 ? function (props) {
      return getFormExtraFields(props);
    } : _ref$formExtraFields,
    getInitialCategoryValue = _ref.getInitialCategoryValue,
    props = _objectWithoutProperties(_ref, _excluded);
  return (0, _BaseInjectors.injectToForm)(form, _objectSpread({
    formExtraFields: formExtraFields,
    embedFieldsWithIndex: 1,
    isFormExtended: true,
    excludeFields: ['phone'],
    handleInitialValues: function handleInitialValues(props) {
      var e = Object.assign.apply(Object, [{}].concat(_toConsumableArray(handleInitialValuesKeys().map(function (key) {
        return _defineProperty({}, key, '');
      }))));
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, e), CategoryOfStoreField && {
        category: getInitialCategoryValue ? getInitialCategoryValue(props.categories) : ''
      }), useAddressOfStore && setInitialAddressOfStoreValues(null, {
        exclude: ['address-state']
      })), {}, {
        specificities: []
      });
    }
  }, props));
}
var _default = buildInjectToForm();
exports.default = _default;